module.exports = __webpack_public_path__ + "img/144.064a0dee.jpg";